// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"60979a3f","466":"54e86322","530":"49f97139","660":"50426053"}[chunkId] + ".chunk.css";
};